<template>
  <!-- PAGINATION -->
  <v-row class="pa-2 align-center justify-center">

    <v-btn
    v-if="!compact && paginationLength > 1"
    text
    :disabled="page <= 0"
    @click="$emit('goToFirstPage')"
    class="mr-2"
    >
      1
    </v-btn>

    <v-btn
    text
    :disabled="page <= 0"
    @click="$emit('goToPreviousPage')"
    class="mr-2"
    >
      <v-icon>mdi-chevron-left</v-icon>
    </v-btn>

    <c-input :value.sync="localPage" style="max-width: 3em;">
    </c-input>

    <span class="overline">
      / {{ paginationLength || 1 }}
    </span>

    <v-btn
    :disabled="page >= paginationLength - 1"
    text
    @click="$emit('goToNextPage')"
    class="ml-2 mr-2"
    >
      <v-icon>mdi-chevron-right</v-icon>
    </v-btn>

    <v-btn
    v-if="!compact && paginationLength > 1"
    text
    :disabled="!(page < (paginationLength - 1))"
    @click="$emit('goToLastPage')"
    class="mr-2"
    >
      {{ paginationLength || 1 }}
    </v-btn>

    <v-spacer></v-spacer>

    <template>
      <items-per-page :rowsPerPage.sync="localRowsPerPage" class="mr-2"></items-per-page>
    </template>

  </v-row>
  <!-- PAGINATION -->
</template>

<script>
import CSListItemsPerPage from '../list-server/C-SListItemsPerPage'

export default {
  props: {
    page: null,
    paginationLength: null,
    paginatedArray: null,
    rowsPerPage: null,
    // Settings
    compact: {
      type: Boolean,
      default: false
    }
  },
  components: {
    'items-per-page': CSListItemsPerPage
  },
  computed: {
    localRowsPerPage: {
      get () {
        return this.rowsPerPage
      },
      set (nv) {
        this.$emit('update:rowsPerPage', nv)
      }
    },
    localPage: {
      get () {
        return this.page + 1
      },
      set (nv) {
        this.$emit('updatePageNumber', nv - 1)
      }
    }
  }
}
</script>